

@if (!linkToPdfContract?.isOfficeDocument) {
  <div
    class="pdf-native-viewer"
    [innerHTML]="linkToPdfContract?.safePdfHtml">
  </div>
}



@if (linkToPdfContract?.isOfficeDocument) {
  <div>
    <iframe
      [src]="linkToPdfContract?.safeOfficeFileLink"
      width='800px'
      height='800px'
      frameborder='0'>
      This is an embedded
      <a target='_blank' href='http://office.com'>
      Microsoft Office</a> document, powered by
      <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
    </div>
  }

